
<div class="menu-container" >
  <div class="close-container" *ngIf="!utilService.trainerMode" >
    <ion-label class="qid"> Q{{utilService.questionId}}</ion-label>
    <ion-img src="assets/images/close.svg" (click)="closeFilterMenu()"></ion-img>
  </div>
  <div class="nav-container" *ngIf="!utilService.trainerMode" >
   <ion-text class="details-text">FILTERS</ion-text>
  </div>

  <div class="filter-container" >
    <div class="spinner"  *ngIf="!utilService.filterDataLoaded"> <app-spinner ></app-spinner></div>
    <div class="data-not-found" *ngIf="utilService.filterDataLoaded && utilService.filterDataNotFound">
      <ion-label>Filter is not available for this data</ion-label>
    </div>
    <ion-accordion-group [multiple]="true" *ngIf="utilService.filterDataLoaded && !utilService.filterDataNotFound">
      <ion-accordion value="first"  toggleIcon="caret-down">
        <ion-item slot="header"  class="header">
          <ion-label>X-axis labels</ion-label>
        </ion-item>
        <div class="ion-padding" slot="content">
          <ion-accordion-group [multiple]="true">
          <ion-accordion  *ngFor="let item of dimensions"  toggleIcon="caret-down">
            <ion-item slot="header" class="sub-header">
              <ion-label> {{ item }}</ion-label>
            </ion-item>
            <div class="ion-padding" slot="content" class="labels-sub-content">
            <div  *ngFor="let option of getOptions(item)"  >
              <mat-checkbox  [(ngModel)]="checkedLabels[option]"  (change)="selectedOption(option, item, $event.checked)"   >
                {{option}}
                 </mat-checkbox>
            </div>
            
            </div>
          
          </ion-accordion>
          </ion-accordion-group>
        </div>
      
      </ion-accordion>
      <ion-accordion value="second"  toggleIcon="caret-down">
        <ion-item slot="header" class="header" >
          <ion-label>Select Metrices</ion-label>
        </ion-item>
        <div class="ion-padding" slot="content" class="sub-content">
        
            
              <div *ngFor="let item of updatedMinMaxmetrices; let i = index" class="sub-content-item">
                <mat-checkbox  [(ngModel)]="checkedMatrices[item.metric]" (change)="selectedMatrices(item.metric, $event.checked)">
                  {{item.metric |formatString}}
                </mat-checkbox>
                <form [formGroup]="metricRangeForm">
                  <div formArrayName="metrics">
                <div [formGroupName]="i">
                 
                  
                  <div class="y-range-container" *ngIf="getMetricValue(i) ">
                    <div class="y-range-box">
                      <ion-label>Min:</ion-label>
                      <ion-input class="y-range-input" type="number" [formControlName]="'min'" (ionInput)="getMatricMinValue(item.metric, $event,i)">
                      </ion-input>
                    </div>
                    <div class="y-range-box">
                      <ion-label>Max:</ion-label>
                      <ion-input class="y-range-input" type="number" [formControlName]="'max'" (ionInput)="getMatricMaxValue(item.metric, $event,i)">
                      </ion-input>
                    </div>
                  </div>
                </div>
                </div>
              </form>
              </div>
        </div>
        
      </ion-accordion>
    </ion-accordion-group>
    <div class="filter-btn" *ngIf="utilService.filterDataLoaded && !utilService.filterDataNotFound">
      <app-submit buttonText="Reset" buttonType="rectCancel" (click)="resetDatasets()" ></app-submit>
    </div>
  </div> 
   
 </div>
 